/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import a from "prop-types";
import { createPropsContext as j, validatePackage as K, usePropsContext as L, useId as O, dispatchEvent as u, classNames as S, kendoThemeMaps as $, getTabIndex as q } from "@progress/kendo-react-common";
import { packageMetadata as A } from "../package-metadata.mjs";
const G = j(), C = e.forwardRef((y, B) => {
  K(A);
  const P = L(G, y), {
    ariaDescribedBy: x,
    checked: m,
    children: b,
    className: E,
    disabled: n,
    id: p,
    size: s = J.size,
    label: r,
    labelPlacement: F,
    name: I,
    style: N,
    tabIndex: R,
    value: c,
    valid: z,
    onChange: f,
    onFocus: i,
    onBlur: d,
    ...T
  } = P, l = e.useRef(null), g = e.useCallback(
    () => {
      l.current && l.current.focus();
    },
    []
  ), o = e.useCallback(
    () => ({
      element: l.current,
      focus: g
    }),
    [g]
  );
  e.useImperativeHandle(B, o);
  const k = O(), M = e.useCallback(
    (t) => {
      u(
        f,
        t,
        o(),
        { value: c }
      );
    },
    [f, c, n]
  ), w = e.useCallback(
    (t) => {
      i && !n && u(
        i,
        t,
        o(),
        void 0
      );
    },
    [i, n]
  ), D = e.useCallback(
    (t) => {
      d && !n && u(
        d,
        t,
        o(),
        void 0
      );
    },
    [d, n]
  ), H = {
    type: "radio",
    id: p || k,
    name: I,
    className: S(
      "k-radio",
      {
        [`k-radio-${$.sizeMap[s] || s}`]: s,
        "k-invalid": z === !1,
        "k-checked": m
      },
      E
    ),
    ref: l,
    disabled: n,
    tabIndex: q(R, n),
    checked: m,
    style: N,
    "aria-describedby": x,
    value: c,
    onChange: M,
    onFocus: w,
    onBlur: D,
    ...T
  }, h = /* @__PURE__ */ e.createElement(e.Fragment, null, r !== void 0 ? /* @__PURE__ */ e.createElement(
    "label",
    {
      className: "k-radio-label",
      htmlFor: p || k,
      style: { userSelect: "none" },
      "aria-label": r
    },
    r
  ) : null), v = /* @__PURE__ */ e.createElement("span", { className: "k-radio-wrap" }, /* @__PURE__ */ e.createElement("input", { ...H }));
  return F === "before" ? /* @__PURE__ */ e.createElement(e.Fragment, null, h, v, b) : /* @__PURE__ */ e.createElement(e.Fragment, null, v, h, b);
});
C.propTypes = {
  ariaDescribedBy: a.string,
  checked: a.bool,
  className: a.string,
  disabled: a.bool,
  id: a.string,
  size: a.oneOf([null, "small", "medium", "large"]),
  label: a.string,
  labelPlacement: a.string,
  name: a.string,
  style: a.object,
  tabIndex: a.number,
  value: a.any,
  valid: a.bool,
  onChange: a.func,
  onFocus: a.func,
  onBlur: a.func
};
const J = {
  size: "medium"
};
C.displayName = "KendoRadioButton";
export {
  C as RadioButton,
  G as RadioButtonPropsContext
};
